import handleRemoveItemClick from './handle-remove-item-click'

export default () => handleRemoveItemClick()
